module.exports = __webpack_public_path__ + "img/cimb.736510fb.svg";